import React from "react";
import "./Practice_Areas.css";
import { Link } from "react-router-dom";

const services = [
  {
    title: "חלוקת רכוש ואיזון משאבים",
    desc: "ייעוץ וייצוג בסוגיות חלוקת רכוש בין בני זוג, לרבות דירות, נכסים, חסכונות, זכויות סוציאליות, חובות ואיזון משאבים.",
    path: "/Property_Distribution_and_Resource_Balancing",
    icon: "scales",
  },
  {
    title: "אחריות הורית וזמני שהות",
    desc: "ליווי וייצוג משפטי בסוגיות אחריות הורית, קביעת זמני שהות והסדרים הנוגעים לגידול הילדים, תוך התייחסות לטובתם.",
    path: "/Parental_Responsibility_and_Visitation_Time",
    icon: "family",
  },
  {
    title: "מזונות ילדים ומזונות אישה",
    desc: "ייעוץ וייצוג בענייני מזונות ילדים ומזונות אישה, קביעת חיובים, שינוי נסיבות ומחלוקות הנוגעות לתשלומי מזונות.",
    path: "/Child_Support_and_Wife_Support",
    icon: "money",
  },
  {
    title: "ענייני בית הדין הרבני",
    desc: "ייצוג וליווי בהליכים בפני בתי הדין הרבניים, לרבות הליכי גירושין, גט וסוגיות משפחתיות הנמצאות בסמכות בית הדין.",
    path: "/Matters_of_the_Rabbinical_Court",
    icon: "court",
  },
  {
    title: "הסכמי גירושין וגישור",
    desc: "עריכת הסכמי גירושין וליווי בהליכי הידברות וגישור, במטרה להסדיר את סוגיות הפרידה באופן ברור ומוסכם.",
    path: "/Urgent_Orders_and_Protection",
    icon: "document",
  },
  {
    title: "צווים דחופים והליכי הגנה",
    desc: "טיפול בבקשות לצווים דחופים ובהליכי הגנה במצבים משפחתיים מורכבים, בהתאם לנסיבות המקרה ולהוראות הדין.",
    path: "/Urgent_Orders_and_Protection",
    icon: "protection",
  },
  {
    title: "מרוץ הסמכויות",
    desc: "ייעוץ משפטי בסוגיות סמכות השיפוט בין בית המשפט לענייני משפחה לבין בית הדין הרבני, ובחינת המשמעויות של ניהול ההליך.",
    path: "/The_race_for_authority",
    icon: "scales",
  },
  {
    title: "גירושין בינלאומיים",
    desc: "ליווי משפטי בסוגיות גירושין בעלות זיקה למדינות שונות, לרבות שאלות סמכות, הכרה בפסקי דין והיבטים בינלאומיים.",
    path: "/International_Divorce",
    icon: "international",
  },
  {
    title: "נישואין אזרחיים ופסולי חיתון",
    desc: "ייעוץ וייצוג בסוגיות הנוגעות לנישואין אזרחיים, התרת נישואין ומעמדם של בני זוג שאינם יכולים להינשא באמצעות הרבנות.",
    path: "/Civil_Marriage_and_Invalid_Marriage",
    icon: "document",
  },
  {
    title: "תביעות נזיקין בין בני זוג",
    desc: "ייעוץ וייצוג בתביעות נזיקיות בין בני זוג ובבחינת עילות משפטיות אפשריות בהתאם לנסיבות ולמסגרת הדין.",
    path: "/SpousalTortClaims",
    icon: "scales",
  },
  {
    title: "יחסי ממון וצוואות בגירושין",
    desc: "ייעוץ בסוגיות יחסי ממון, הסכמי ממון, זכויות רכושיות והיבטים הנוגעים לצוואות ולהשלכות הליכי הגירושין.",
    path: "/Prenuptial_Relations_and_Wills_in_Divorce",
    icon: "document",
  },
  {
    title: "אפוטרופסות וניכור הורי",
    desc: "ליווי משפטי בענייני אפוטרופסות, קבלת החלטות בענייני ילדים וטיפול בסוגיות של ניכור הורי, בהתאם לנסיבות המקרה.",
    path: "/Guardianship_and_Parental_Alienation",
    icon: "family",
  },
  {
    title: "ידועים בציבור ותאים משפחתיים חלופיים",
    desc: "ייעוץ משפטי לידועים בציבור ולבני זוג במבנים משפחתיים מגוונים, לרבות הסכמים, זכויות רכושיות והסדרת היחסים.",
    path: "/Common_Law_Partners_and_Surrogate_Family_Units",
    icon: "family",
  },
  {
    title: "ייפוי כוח מתמשך",
    desc: "ייעוץ וליווי בעריכת ייפוי כוח מתמשך, המאפשר לאדם לקבוע מראש מי יטפל בענייניו וכיצד יתקבלו החלטות עבורו בעתיד.",
    path: "/Enduring_Power_of_Attorney",
    icon: "document",
  },
];

function LegalIcon({ type }) {
  const common = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  const icons = {
    court: (
      <>
        <path d="M3 10h18L12 4 3 10Z" />
        <path d="M5 10v9M9 10v9M15 10v9M19 10v9M3 21h18M2 19h20" />
      </>
    ),
    scales: (
      <>
        <path d="M12 3v17M7 21h10M5 6h14M12 3l-2 2m2-2 2 2" />
        <path d="m5 6-3 7h6L5 6Zm14 0-3 7h6l-3-7Z" />
        <path d="M2 13c0 2 1 3 3 3s3-1 3-3M16 13c0 2 1 3 3 3s3-1 3-3" />
      </>
    ),
    family: (
      <>
        <circle cx="9" cy="7" r="3" />
        <circle cx="17" cy="8" r="2.5" />
        <path d="M3 20v-2a6 6 0 0 1 12 0v2H3ZM15 14a5 5 0 0 1 6 5v1h-4" />
      </>
    ),
    money: (
      <>
        <rect x="3" y="6" width="18" height="13" rx="2" />
        <path d="M3 10h18M12 12v1M12 16v1M7 3h10" />
        <circle cx="12" cy="13" r="2" />
      </>
    ),
    document: (
      <>
        <path d="M6 3h9l4 4v14H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" />
        <path d="M14 3v5h5M8 12h8M8 16h8" />
      </>
    ),
    protection: (
      <>
        <path d="M12 3 20 6v5c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-3Z" />
        <path d="m9 12 2 2 4-4" />
      </>
    ),
    international: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
      </>
    ),
  };

  return (
    <div className="service-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" {...common}>
        {icons[type] || icons.court}
      </svg>
    </div>
  );
}

export default function Practice_Areas() {
  return (
    <section className="services-page">
      <div className="services-container">
        <header className="services-heading">
          <h1>
            תחומי העיסוק <span>שלנו</span>
          </h1>

          <div className="services-heading-line" />

          <p>
            משרד עורכי הדין רז יוסף מעניק ייעוץ, ליווי וייצוג משפטי
            בתחומי דיני המשפחה, הגירושין והעניינים הנלווים להם.
            המשרד מקפיד על מקצועיות, דיסקרטיות, יחס אישי ובחינה
            מעמיקה של נסיבותיו הייחודיות של כל מקרה.
          </p>
        </header>

        <div className="services-grid">
          {services.map((item) => (
            <Link
              to={item.path}
              key={item.title}
              className="service-card"
            >
              <div className="service-content">
                <div className="service-card-top">
                  <LegalIcon type={item.icon} />
                </div>

                <h2>{item.title}</h2>

                <p>{item.desc}</p>

                <div className="service-card-bottom">
                  <span>לפרטים נוספים</span>
                  <span className="service-arrow">←</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
